import  {Theme }                        from '@material-ui/core/styles';
import merge                            from 'deepmerge';
import { themeTypePalettes, ThemeType } from './DataTypes';

export default function getWorkSightInnerTheme(theme: Theme, themeType?: ThemeType): Theme {
  const mainTheme         = merge({}, theme);
  const mainPageContainer = () => document.getElementById('main-page-root');
  mainTheme.props         = merge(mainTheme.props || {}, {
    MuiModal: {
      container: mainPageContainer,
    },
    MuiPopover: {
      container: mainPageContainer,
    },
    MuiDialog: {
      container: mainPageContainer,
    },
    MuiMenu: {
      container: mainPageContainer,
    },
  });

  if (!themeType || themeType === 'default') {
    return mainTheme;
  }

  // add light, dark, and contrastText color values for custom colors.
  const themeTypePalette            = themeTypePalettes[themeType];
  mainTheme.palette.primary         = mainTheme.palette.augmentColor({...themeTypePalette.primary});
  mainTheme.palette.secondary       = mainTheme.palette.augmentColor({...themeTypePalette.secondary});
  mainTheme.palette.error           = mainTheme.palette.augmentColor({...themeTypePalette.error});
  mainTheme.palette.neutral         = mainTheme.palette.augmentColor({...themeTypePalette.neutral});
  mainTheme.palette.neutralLight    = mainTheme.palette.augmentColor({...themeTypePalette.neutralLight});
  mainTheme.palette.navBarPrimary   = mainTheme.palette.augmentColor({...themeTypePalette.navBarPrimary});
  mainTheme.palette.navBarSecondary = mainTheme.palette.augmentColor({...themeTypePalette.navBarSecondary});
  mainTheme.palette.dialogPrimary   = mainTheme.palette.augmentColor({...themeTypePalette.dialogPrimary});
  mainTheme.palette.gridSelect      = mainTheme.palette.augmentColor({...themeTypePalette.gridSelect});
  mainTheme.palette.success         = mainTheme.palette.augmentColor({...themeTypePalette.success});
  mainTheme.palette.info            = mainTheme.palette.augmentColor({...themeTypePalette.info});
  mainTheme.palette.warning         = mainTheme.palette.augmentColor({...themeTypePalette.warning});
  mainTheme.palette.highlight       = mainTheme.palette.augmentColor({...themeTypePalette.highlight});

  mainTheme.overrides = merge(mainTheme.overrides || {}, {
    MuiInput: {
      underline: {
        '&::after': {
          borderColor: mainTheme.palette!.dialogPrimary.main,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          borderColor: mainTheme.palette.dialogPrimary.main,
        },
      },
    },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: mainTheme.palette!.dialogPrimary.main,
        },
      },
    },
    MuiMenuItem: {
      root: {
        '&:hover': {
          backgroundColor: mainTheme.palette!.neutralLight.light,
        },
        '&$selected, &:active': {
          backgroundColor: mainTheme.palette!.dialogPrimary.main,
          color: mainTheme.palette.dialogPrimary.contrastText,
          '& > *': {
            color: mainTheme.palette.dialogPrimary.contrastText,
          },
          '&:hover, &:focus': {
            backgroundColor: mainTheme.palette!.dialogPrimary.main,
          },
        },
      },
    },
    MuiListSubheader: {
      root: {
        backgroundColor: mainTheme.palette.neutralLight.main,
        color: `${mainTheme.palette.neutralLight.contrastText} !important`,
      },
      sticky: {
        backgroundColor: mainTheme.palette!.neutralLight.main,
        color: `${mainTheme.palette.neutralLight.contrastText} !important`,
      },
    },
    MuiButton: {
      outlined: {
        borderColor: mainTheme.palette!.neutral.main,
      },
    },
    MuiCheckbox: {
      root: {
        color: mainTheme.palette!.dialogPrimary.main,
        '&$checked': {
          color: mainTheme.palette!.dialogPrimary.main,
        },
      },
      colorPrimary: {
        color: mainTheme.palette!.dialogPrimary.main,
        '&$checked': {
          color: mainTheme.palette!.dialogPrimary.main,
        },
      },
    },
    MuiSwitch: {
      root: {
        color: mainTheme.palette!.dialogPrimary.main,
      },
    },
  });

  return mainTheme;
}
